import { useEffect } from "react";
import { ContainerV2, H1, P } from "../../Atoms";
import { FormBuscarVeiculoV2 } from "../../Molecules/FormBuscarVeiculoV2";
import { Tracking } from "../../../services/Tracking";
import { useSurveyV2 } from "./useSurveyV2";

export const SurveyV2 = () => {
  const { stepIndicator, handleSubmit } = useSurveyV2();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento/servicos/vistoria:pageview");
  });

  return (
    <ContainerV2 nextButton={{ title: "Avançar", disabled: true }}>
      {stepIndicator}
      <H1 className="mb-4 mt-8">Identifique o veículo</H1>
      <P className="mb-6 text-[#666666]">
        Consultamos as informações automaticamente. Você só precisa confirmar.
      </P>

      <FormBuscarVeiculoV2 modo="placa" onSubmitForm={handleSubmit} />
    </ContainerV2>
  );
};
